const closePopups = () => {
  document
    .querySelectorAll(".js-popup")
    .forEach((popup) => popup.classList.remove("is-active"));

  document.body.classList.remove("overflow-hidden");
};

const openPopup = (popupId) => {
  const popup = document.querySelector(`.js-popup[data-popup="${popupId}"]`);

  if (popup) {
    popup.classList.add("is-active");
    localStorage.setItem(`popup-${popupId}`, "opened");
    document.body.classList.add("overflow-hidden");
  }
};

const initPopups = () => {
  // Close popup
  document
    .querySelectorAll(".js-close-popups")
    .forEach((el) => el.addEventListener("click", () => closePopups()));

  // Open popups with class
  document.querySelectorAll(".js-open-popup").forEach((trigger) =>
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      if (trigger.hasAttribute("data-popup")) {
        openPopup(trigger.getAttribute("data-popup"));
      }
    }),
  );

  // Open booking popup with booking class
  document.querySelectorAll(".js-open-booking").forEach((trigger) =>
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      openPopup("booking");
    }),
  );

  // Open popups by href
  // href="#popup:popupId" = Open popup with data attr of: data-popup="popupID"
  document.querySelectorAll("a[href*='#']").forEach((aTag) => {
    aTag.addEventListener("click", function (event) {
      event.preventDefault();

      let href = aTag.getAttribute("href");
      if (href) {
        const hashIndex = href.indexOf("#");
        if (hashIndex !== -1) {
          const hashRaw = href.substring(hashIndex + 1);
          const hashValue = hashRaw.split(":");

          if (hashValue.length > 1 && hashValue[0] == "popup" && hashValue[1]) {
            openPopup(hashValue[1]);
          }
        }
      }
    });
  });

  // Close popups on escape key press
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closePopups();
    }
  });
};

export { openPopup, closePopups, initPopups };
